import { render, staticRenderFns } from "./BasePageForm.vue?vue&type=template&id=d292457e&scoped=true&"
import script from "./BasePageForm.vue?vue&type=script&lang=js&"
export * from "./BasePageForm.vue?vue&type=script&lang=js&"
import style0 from "./BasePageForm.vue?vue&type=style&index=0&id=d292457e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d292457e",
  null
  
)

export default component.exports